import { AsphaltLotReportItem } from '../classes/asphalt'

export const AsphaltCoreSheet = new AsphaltLotReportItem({
  id: 'B5196D99-9D6C-4F7C-8323-2B7C3F146131',
  name: 'Asphalt Core Sheet',
  queryParameter: 'asphalt-core',
  sampleFilename: 'asphalt-core-sheet',
  description: 'CORE-SHEET',
})

export const AsphaltLot = new AsphaltLotReportItem({
  id: '448A01FE-BB77-45AC-AB3D-E76C5C3D8CCC',
  name: 'Asphalt Lot',
  queryParameter: 'asphalt-lot',
  sampleFilename: 'asphalt-lot',
  description: 'LOT',
})

export type AsphaltReportItem = typeof AsphaltCoreSheet | typeof AsphaltLot
